var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDanger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_14508_118331",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_14508_118331)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4666 30L8.93325 25.7333L4.13325 24.6667L4.59992 19.7333L1.33325 16L4.59992 12.2667L4.13325 7.33333L8.93325 6.26667L11.4666 2L15.9999 3.93333L20.5333 2L23.0666 6.26667L27.8666 7.33333L27.3999 12.2667L30.6666 16L27.3999 19.7333L27.8666 24.6667L23.0666 25.7333L20.5333 30L15.9999 28.0667L11.4666 30ZM15.9999 22.6667C16.3777 22.6667 16.6944 22.5389 16.9499 22.2833C17.2055 22.0278 17.3333 21.7111 17.3333 21.3333C17.3333 20.9556 17.2055 20.6389 16.9499 20.3833C16.6944 20.1278 16.3777 20 15.9999 20C15.6221 20 15.3055 20.1278 15.0499 20.3833C14.7944 20.6389 14.6666 20.9556 14.6666 21.3333C14.6666 21.7111 14.7944 22.0278 15.0499 22.2833C15.3055 22.5389 15.6221 22.6667 15.9999 22.6667ZM14.6666 17.3333H17.3333V9.33333H14.6666V17.3333Z",
    fill: "#D32F2F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDanger);
export default __webpack_public_path__ + "static/media/Danger.46925b95.svg";
export { ForwardRef as ReactComponent };